import _ from "lodash";

const initialState = {
  total: "",
  sort: "form_title",
  data: [],
  datasource: [],
  lookupData: [],
  recovered_form: [],
  recovered_formId: -1,
  recovered_uuid: "",
  recovered_draft: false
};

const forms = (state = initialState, action) => {
  switch (action.type) {
    case "RECEIVE_FORMS":
      return Object.assign({}, state, {
        data: action.forms,
        total: action.total
      });
    case "UPDATE_FORMS":
      let fElement = _.filter(state.data, { form_id: action.form.form_id });
      let replacedfIndex = _.findIndex(state.data, function(lookupItem) {
        return lookupItem.form_id == action.form.form_id;
      });
      if (fElement.length === 1) {
        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, replacedfIndex),
            action.form,
            ...state.data.slice(replacedfIndex + 1)
          ]
        });
      } else {
        return Object.assign({}, state, {
          data: [...state.data, action.form]
        });
      }
    case "SET_DATASOURCE":
      return Object.assign({}, state, {
        datasource: action.datasource
      });
    case "UPDATE_DATASOURCE":
      let dsElement = _.filter(state.datasource, function(dsx) {
        return dsx.datasource_id !== action.datasource.datasource_id;
      });
      return Object.assign({}, state, {
        datasource: [...dsElement, action.datasource]
      });

    case "RESET_RECOVERED_FORM":
      return Object.assign({}, state, {
        recovered_form: [],
        recovered_formId: -1,
        recovered_uuid: "",
        recovered_draft: false
      });
    case "SET_RECOVER_FORM":
      return Object.assign({}, state, {
        recovered_form: action.draft,
        recovered_formId: action.formId,
        recovered_uuid: action.uuid,
        recovered_draft: action.isDraft
      });
    case "SET_LOOKUP_DATA":
      let lookupElement = _.filter(state.lookupData, {
        datasourceId: action.datasourceId
      });
      let replacedLookupIndex = _.findIndex(state.lookupData, function(
        lookupItem
      ) {
        return lookupItem.datasourceId == action.datasourceId;
      });
      if (lookupElement.length === 1) {
        return Object.assign({}, state, {
          lookupData: [
            ...state.lookupData.slice(0, replacedLookupIndex),
            {
              datasourceId: action.datasourceId,
              lookupData: action.lookupData
            },
            ...state.lookupData.slice(replacedLookupIndex + 1)
          ]
        });
      } else {
        return Object.assign({}, state, {
          lookupData: [
            ...state.lookupData,
            { datasourceId: action.datasourceId, lookupData: action.lookupData }
          ]
        });
      }

    case "SORT_FORMS":
      return Object.assign({}, state, {
        sort: action.value
      });
    case "RESET_FORMS":
      return Object.assign({}, state, {
        total: "",
        sort: "form_title",
        data: [],
        datasource: [],
        lookupData: [],
        recovered_form: [],
        recovered_formId: -1,
        recovered_uuid: "",
        recovered_draft: false
      });
    default:
      return state;
  }
};

export default forms;



// WEBPACK FOOTER //
// ./src/reducers/forms.js